import React, { useEffect, useRef, useState } from "react"

import { Link } from "gatsby"

import { Icon } from "@components/icon"

import * as styles from "./menu.module.css"

const Menu = ({ data }) => {
  const [open, setOpen] = useState(false)
  const menuRef = useRef(null)

  useEffect(() => {
    if (!open) {
      return undefined
    }
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [open])

  const links = data.map((item, index) => {
    return (
      <Link
        to={item.link}
        className={styles.link}
        key={index}
        onClick={() => setOpen(false)}
      >
        {item.name}
      </Link>
    )
  })

  return (
    <div className={styles.container} ref={menuRef}>
      <button
        type="button"
        className={styles.button}
        aria-label={open ? "Close menu" : "Menu"}
        aria-haspopup="true"
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
      >
        <Icon id={open ? "xmark" : "bars"} width="24" height="24" />
        <span>MENU</span>
      </button>
      {open && <div className={styles.links}>{links}</div>}
    </div>
  )
}

export default Menu
